import { useSessionContext } from '@issuemanager/apps/client/contexts';

export function useLocale() {
  const session = useSessionContext();
  return session?.locale ?? 'en';
}
